module.exports = "/img/ball-loading.svg?724f31421e14432c9bb404586f998c37";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/identity/ball-loading.svg
// module id = WUKb
// module chunks = 46